import { Component, h, Prop, Host } from "@stencil/core";
import { statusTypes, defaultConfig, StatusType } from "./status-types";

@Component({
    tag: "ux-w-status",
    styleUrl: "status.scss",
    shadow: false
})
export class Status {
    /** type of the status */
    @Prop({ reflect: true }) type: StatusType;

    private static getProperty<T>(
        type: StatusType,
        property: "color" | "icon" | "filled" | "neutralText"
    ) {
        if (type in statusTypes && property in statusTypes[type]) {
            return statusTypes[type][property] as T;
        }
        return defaultConfig[property] as T;
    }

    render() {
        const { type } = this;
        const color = Status.getProperty<string>(type, "color");
        const icon = Status.getProperty<string>(type, "icon");
        const filled = Status.getProperty<boolean>(type, "filled");
        const neutralText = Status.getProperty<boolean>(type, "neutralText");

        return (
            <Host class={`ux-text-status ux-text-status--${color}`}>
                <ux-icon name={icon} filled={filled} />
                <span
                    class={{
                        "ux-w-status__text": true,
                        "ux-w-status__text--neutral": neutralText
                    }}
                >
                    <slot />
                </span>
            </Host>
        );
    }
}
